module.exports = __webpack_public_path__ + "static/media/SocialCircle.d4d4f990.svg";